import { CURRENCIES } from '../constants'

// Define type for AppCurrency based on what's in constants
type AppCurrency = (typeof CURRENCIES)[number]

/**
 * Maps a country code to the appropriate currency.
 * This is used for displaying the correct currency based on the user's location.
 *
 * @param {string} countryCode - The two-letter ISO country code (e.g., 'US', 'DE')
 * @returns {AppCurrency} - The appropriate currency for the country
 */
export function getCurrencyFromCountry(countryCode: string): AppCurrency {
  // Maps of country codes to currencies
  const euroCountries = [
    'AT',
    'BE',
    'CY',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PT',
    'SK',
    'SI',
    'ES',
  ]

  const gbpCountries = ['GB']

  const usdCountries = ['US', 'CA'] // US and Canada show USD

  // Determine currency based on country code
  if (euroCountries.includes(countryCode)) {
    return 'EUR'
  } else if (gbpCountries.includes(countryCode)) {
    return 'GBP'
  } else if (usdCountries.includes(countryCode)) {
    return 'USD'
  }

  // Default to EUR if country is not in any of the lists
  return 'EUR'
}
